import { render, staticRenderFns } from "./settlementDialog.vue?vue&type=template&id=f7348c64"
import script from "./settlementDialog.vue?vue&type=script&lang=js"
export * from "./settlementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports